// src/core/api/careersApi.js
import { axiosClient } from "./axiosClient";

export const careersApi = {
  list: async () => {
    const res = await axiosClient.get("/careers/");
    return res.data;
  },

  detail: async (id) => {
    const res = await axiosClient.get(`/careers/${id}/`);
    return res.data;
  },

  update: async (id, payload) => {
    const res = await axiosClient.patch(`/careers/${id}/`, payload);
    return res.data;
  },

  remove: async (id) => {
    await axiosClient.delete(`/careers/${id}/`);
  },
};
